import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";

import { getTenantFromUrl } from "src/services/tenantUrl";

import {
  DESIGN_OPTION_PARAM,
  buildDesignOptionSearch,
} from "./designOptionSearch";

/**
 * In-app links do not carry ?designOption=, so after a click the selected
 * option lived only in session storage and a copied URL opened Baseline for
 * whoever followed it. This puts the selected option back on the URL after
 * every navigation. A URL that already names an option is left alone: the
 * URL wins, and useDesignOptionId adopts it.
 */
export const useKeepDesignOptionInUrl = (optionId: string | undefined) => {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    if (!optionId) {
      return;
    }
    if (new URLSearchParams(location.search).get(DESIGN_OPTION_PARAM)) {
      return;
    }
    const search = buildDesignOptionSearch(
      location.search,
      optionId,
      getTenantFromUrl()
    );
    // Spread the location so router state (AI dashboard launches and chat
    // hand-offs carry their payload there) and the hash survive the replace.
    history.replace({ ...location, search: `?${search}` });
  }, [optionId, history, location]);
};
